import { useMemo } from "react"
import { numberFormat } from "shared/util"
import { Checkbox, FormControlLabel, Stack, StackProps, Typography } from "@mui/material"
import {
	RectangleRounded as DpcMarkIcon,
	Crop54Rounded as DpcEmptyMarkIcon
} from '@mui/icons-material'
import { useDpcResults } from "../container"

type DpcDiseaseListProps = {
	container: ReturnType<typeof useDpcResults> 
} & StackProps
export const DpcDiseaseList = ({
	container: {
		dpcList,
		selectedDpcList,
		filteredList,
		calcTotalCase,
		selectDpcCode
	},
	...others
}: DpcDiseaseListProps) => {
	const diseaseList = useMemo(
		() => filteredList ? dpcList.flatMap(dpc => {
			const selected = selectedDpcList.find(
				selected => selected.dpcCode === dpc.dpcCode
			)
			const count = filteredList?.reduce(
				(acc, sisetu) => (calcTotalCase(sisetu, dpc.dpcCode) > 0) ? acc + 1 : acc,
				0
			) ?? 0
			if (count === 0) return []
			return { dpc, selected, count }
		}) : undefined,
		[dpcList, selectedDpcList, filteredList, calcTotalCase]
	)
	return (
		<Stack {...others} direction="column" overflow="auto">
			{diseaseList?.map(({ dpc, selected, count }, index) => (
				<Stack
					key={`record-${index}`}
					direction="row"
					alignItems="center"
					spacing={1}
					paddingRight={1}
				>
					<FormControlLabel
						label={dpc.diseaseName}
						control={
							<Checkbox
								value={dpc.dpcCode}
								size="small"
								checked={selected ? true : false}
								onChange={(e) =>
									selectDpcCode(dpc.dpcCode, e.target.checked)
								}
							/>
						}
						sx={{ flexGrow: 1 }}
					/>
					<Typography variant="body2" whiteSpace="nowrap">
						{numberFormat(count)} 施設
					</Typography>

					{selected ? (
						<DpcMarkIcon
							fontSize="small"
							sx={{ color: selected.color, cursor: 'pointer' }}
							onClick={() => selectDpcCode(dpc.dpcCode, false)}
						/>
					) : (
						<DpcEmptyMarkIcon
							fontSize="small"
							sx={{ color: 'lightgray', cursor: 'pointer' }}
							onClick={() => selectDpcCode(dpc.dpcCode, true)}
						/>
					)}
				</Stack>
			))}
		</Stack>
	)
}